import { fetchMe } from "./fetchMe";
import { isAuthenticated } from "@/event/account/auth/authentification";
import { getTokenByDevice } from "./getTokenByDevice";
import { setTokenDevice } from "./setTokenDevice";

export async function checkAndRefreshTokenV2() {
    try {
        const data = getTokenByDevice()
        const result = await fetchMe(data)

        setTokenDevice(result);

        if (result && result.class === 'success') {
            isAuthenticated.value = true
        }

        return result
    } catch (error) {
        return false
    }
}